// This file can be replaced during build by using the `fileReplacements` array.
// `ng build --prod` replaces `environment.ts` with `environment.prod.ts`.
// The list of file replacements can be found in `angular.json`.

export const environment = {
  production: true,
  collectionName: 'services_V1.0.2',
  firebaseConfig: {
    apiKey: 'AIzaSyAh_uuLp-Gjp4pevyPo6Mt66ekJ2BFNcp4',
    authDomain: 'radimdienst.firebaseapp.com',
    projectId: 'radimdienst',
    storageBucket: 'radimdienst.appspot.com',
    messagingSenderId: '826697847089',
    appId: '1:826697847089:web:f727811f2e1a26fd502010',
    measurementId: 'G-8E46J2L80G',
  },
};

/*
 * For easier debugging in development mode, you can import the following file
 * to ignore zone related error stack frames such as `zone.run`, `zoneDelegate.invokeTask`.
 *
 * This import should be commented out in production mode because it will have a negative impact
 * on performance if an error is thrown.
 */
// import 'zone.js/plugins/zone-error';  // Included with Angular CLI.
